/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlagCreate
 */
export interface FlagCreate {
    /**
     * 
     * @type {string}
     * @memberof FlagCreate
     */
    comment?: string | null;
}

/**
 * Check if a given object implements the FlagCreate interface.
 */
export function instanceOfFlagCreate(value: object): value is FlagCreate {
    return true;
}

export function FlagCreateFromJSON(json: any): FlagCreate {
    return FlagCreateFromJSONTyped(json, false);
}

export function FlagCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlagCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function FlagCreateToJSON(json: any): FlagCreate {
    return FlagCreateToJSONTyped(json, false);
}

export function FlagCreateToJSONTyped(value?: FlagCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
    };
}

